export default {
    title: 'Scheduled preventive maintenance'
}